import React from 'react';
import styled, { css } from 'styled-components';
import { ImageType } from '../../../hooks/api/queries/useProducts';
import { S3_URL } from '../../../styles/constants';

interface Props {
  image?: ImageType;
  background?: boolean;
  eager?: boolean;
}

export const WImage = React.memo(({ image, background = false, eager = false }: Props) => {
  return image?.path ? (
    <Image
      src={`${S3_URL}${image.path}`}
      alt={image.alt ?? ''}
      $background={background}
      loading={eager ? 'eager' : 'lazy'}
      decoding="async"
    />
  ) : (
    <Image src="/images/category-pic-1.png" $background={true} loading="lazy" decoding="async" />
  );
});

const Image = styled.img<{ $background: boolean }>`
  width: 100%;
  ${({ $background }) =>
    $background &&
    css`
      background: rgba(0, 0, 0, 0.05);
    `}
`;
